"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAttributeProperties = void 0;
const index_js_1 = require("../../errors/index.js");
const isBoolean_js_1 = require("../../utils/validation/isBoolean.js");
const isString_js_1 = require("../../utils/validation/isString.js");
const requiredOptions_js_1 = require("../constants/requiredOptions.js");
/**
 * Validates an attribute shared properties
 *
 * @param attribute Attribute
 * @param path Path of the instance in the related schema (string)
 * @return void
 */
const validateAttributeProperties = (attribute, path) => {
    const attributeRequired = attribute.required;
    if (!requiredOptions_js_1.requiredOptionsSet.has(attributeRequired)) {
        throw new index_js_1.DynamoDBToolboxError('schema.attribute.invalidProperty', {
            message: `Invalid option value type${path !== undefined ? ` at path '${path}'` : ''}. Property: 'required'. Expected: ${[...requiredOptions_js_1.requiredOptionsSet].join(', ')}. Received: ${String(attributeRequired)}.`,
            path,
            payload: {
                propertyName: 'required',
                expected: [...requiredOptions_js_1.requiredOptionsSet].join(', '),
                received: attributeRequired
            }
        });
    }
    const attributeHidden = attribute.hidden;
    if (!(0, isBoolean_js_1.isBoolean)(attributeHidden)) {
        throw new index_js_1.DynamoDBToolboxError('schema.attribute.invalidProperty', {
            message: `Invalid option value type${path !== undefined ? ` at path '${path}'` : ''}. Property: 'hidden'. Expected: boolean. Received: ${String(attributeHidden)}.`,
            path,
            payload: {
                propertyName: 'hidden',
                received: attributeRequired
            }
        });
    }
    const attributeKey = attribute.key;
    if (!(0, isBoolean_js_1.isBoolean)(attributeKey)) {
        throw new index_js_1.DynamoDBToolboxError('schema.attribute.invalidProperty', {
            message: `Invalid option value type${path !== undefined ? ` at path '${path}'` : ''}. Property: 'key'. Expected: boolean. Received: ${String(attributeHidden)}.`,
            path,
            payload: {
                propertyName: 'key',
                received: attributeHidden
            }
        });
    }
    const attributeSavedAs = attribute.savedAs;
    if (attributeSavedAs !== undefined && !(0, isString_js_1.isString)(attributeSavedAs)) {
        throw new index_js_1.DynamoDBToolboxError('schema.attribute.invalidProperty', {
            message: `Invalid option value type${path !== undefined ? ` at path '${path}'` : ''}. Property: 'savedAs'. Expected: string. Received: ${String(attributeSavedAs)}.`,
            path,
            payload: {
                propertyName: 'savedAs',
                received: attributeSavedAs
            }
        });
    }
};
exports.validateAttributeProperties = validateAttributeProperties;
